<article
  class="group flex cursor-pointer items-center gap-3 rounded-lg border border-gray-200 bg-white p-4 transition-shadow hover:shadow-md"
  [attr.data-testid]="'client.card.' + client.id"
  (click)="onCardClick()"
  (keydown.enter)="onCardClick()"
  tabindex="0"
  role="button"
>
  <div
    class="flex size-10 shrink-0 items-center justify-center overflow-hidden rounded-full bg-primary-100"
  >
    @if (client.logoUrl) {
      <img
        [src]="client.logoUrl"
        [alt]="client.name"
        class="size-full object-cover"
      />
    } @else {
      <lucide-angular
        [img]="UserIcon"
        [size]="20"
        class="text-primary-600"
      ></lucide-angular>
    }
  </div>
  <div class="min-w-0 flex-1">
    <h3
      class="truncate font-semibold text-greyscale-900"
      [pTooltip]="client.name"
      tooltipPosition="top"
      [tooltipOptions]="{ showDelay: 500 }"
    >
      {{ client.name }}
    </h3>
    <p class="text-sm text-greyscale-600">
      {{ tripCount }}
      {{
        tripCount === 1
          ? ('companyClientList.associatedTrip' | transloco)
          : ('companyClientList.associatedTrips' | transloco)
      }}
    </p>
  </div>
  <div
    class="shrink-0"
    (click)="$event.stopPropagation()"
    (keydown.enter)="$event.stopPropagation()"
    tabindex="-1"
    role="group"
  >
    <app-actions [options]="actions" />
  </div>
</article>
